import { z } from 'zod';
import i18n from 'i18n';
import { InvitedParticipant } from './types';

export const createInviteParticipantSchema = (participants: InvitedParticipant[]) =>
  z.object({
    firstName: z.string().trim().min(1),
    lastName: z.string().trim(),
    email: z
      .email({ error: () => '' })
      .trim()
      .min(1, { error: () => '' })
      .refine((email) => !participants.some((p) => p.email.toLowerCase() === email.toLowerCase()), {
        message: i18n.t('participants:invite_participants.validation.duplicate_email'),
      }),
    role: z.string().min(1),
  });

export type InviteParticipantFormValues = z.infer<ReturnType<typeof createInviteParticipantSchema>>;
